var _defs, _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMongoose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "moongoose",
    x1: 24.2,
    x2: 25.6,
    y1: 47.6,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74cb32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#abeb6b"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "url(#moongoose)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#283d16",
    d: "M31 10s-2.3 2.2-4.8 3.1C7.8 19.8 15.5 32.8 15.8 33c0 0 1-1.8 2.4-2.9C27.1 23.5 29 16 29 16s-2 9-9.9 14.7c-1.7 1.2-2.9 4.2-3.4 7.3l1.8-.6c.2-1.4.6-2.7 1.3-3.8a13 13 0 0015.1-10.7C35 15.6 31 10 31 10"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongoose);
export default __webpack_public_path__ + "static/media/Mongoose.2d928742.svg";
export { ForwardRef as ReactComponent };